module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HLKBAS/tc-custom/9781459232556.jpg?1720083899709",
      "alt": "This image is the cover for the book Secret Cinderella"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret Cinderella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("DESPERATELY SEEKING PRINCE CHARMING")]), _c('br'), _c('br'), _vm._v("Her desperate plan to save her brother left Melanie Andrews with a dead body on her hands, a killer at her heels and nowhere to runexcept into Roderick Laughlin’s arms. As soon as she saw the seductive, self-made man in the crowded ballroom, she knew she’d found a temporary haven. And as the clock struck twelve, Melanie pressed a burning kiss on his lips and escaped into the night, thinking she’d never see him again."), _c('br'), _c('br'), _vm._v("She thought wrong."), _c('br'), _c('br'), _vm._v("The taste of her was seared into his mind, and there was nowhere Roderick’s mysterious Cinderella could hide. Because she’d gotten mixed up in a deadly game, one only Roderick could protect her fromas soon as he convinced her he was the only man to trust.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dani Sinclair\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0